import gql from "graphql-tag";

const previewProductFields = `
  id
  productCode
  name
  category {
    description
  }
`;

const productAddResultFields = `
  addedCount
  notFoundArticles
  duplicateArticles
  dealerIncentive {
    id
  }
`;

export const dealerIncentiveProductsPreviewByArticlesQuery = gql`
  query dealerIncentiveProductsPreviewByArticles($articles: [String!]!) {
    dealerIncentiveProductsPreviewByArticles(articles: $articles) {
      products {
        ${previewProductFields}
      }
      notFoundArticles
    }
  }
`;

export const dealerIncentiveProductsPreviewByCategoryQuery = gql`
  query dealerIncentiveProductsPreviewByCategory(
    $catalogCategoryId: ID!
    $first: Int
    $page: Int
  ) {
    dealerIncentiveProductsPreviewByCategory(
      catalogCategoryId: $catalogCategoryId
      first: $first
      page: $page
    ) {
      data {
        ${previewProductFields}
      }
      paginatorInfo {
        currentPage
        lastPage
        perPage
        total
      }
    }
  }
`;

export const previewDealerIncentiveProductsFromExcelMutation = gql`
  mutation previewDealerIncentiveProductsFromExcel($file: Upload!) {
    previewDealerIncentiveProductsFromExcel(file: $file) {
      products {
        ${previewProductFields}
      }
      notFoundArticles
    }
  }
`;

export const addDealerIncentiveProductsByIdsMutation = gql`
  mutation addDealerIncentiveProductsByIds(
    $dealerIncentiveId: ID!
    $productIds: [ID!]!
  ) {
    addDealerIncentiveProductsByIds(
      dealerIncentiveId: $dealerIncentiveId
      productIds: $productIds
    ) {
      ${productAddResultFields}
    }
  }
`;

export const removeDealerIncentiveProductsMutation = gql`
  mutation removeDealerIncentiveProducts($dealerIncentiveId: ID!, $productIds: [ID!]!) {
    removeDealerIncentiveProducts(dealerIncentiveId: $dealerIncentiveId, productIds: $productIds) {
      id
    }
  }
`;
